import { svgPathTypes } from "@/components/Icon";
import { configStore } from "@/stores/configStore";

// 主分类类型
export type MainCategoryTypes = "Casino" | "Sports";

// casino - subCategory - gclass
export const casinoSubCategoryList = [
  { key: "All Games", label: "search.all_games", value: "" },
  { key: "Originals", label: "search.originals", value: 10 }, // value: click_id
  { key: "Slots", label: "search.slots", value: 2 },
  { key: "Live", label: "search.live", value: 3 },
  { key: "Show", label: "search.show", value: 5 },
  { key: "Special", label: "search.special", value: 1 },
  // { key: "Lottery", value: 6 },
];

// sports - subCategory - betby - sport_priority_type = 1
export const sportsSubCategoryListBetby = [
  { key: "Live", label: "search.live", value: 0 },
  { key: "Soccer", label: "search.soccer", value: 1 },
  { key: "Basketball", label: "search.basketball", value: 2 },
  { key: "Tennis", label: "search.tennis", value: 5 },
  { key: "Baseball", label: "search.baseball", value: 3 },
  { key: "Volleyball", label: "search.vollyball", value: 23 },
];

// sports - subCategory - first - sport_priority_type = 2
export const sportsSubCategoryListFirst = [
  { key: "Live", label: "search.live", value: 0 },
  { key: "Soccer", label: "search.soccer", value: 1 },
  { key: "Basketball", label: "search.basketball", value: 2 },
  { key: "Tennis", label: "search.tennis", value: 6 },
  { key: "Baseball", label: "search.baseball", value: 7 },
  { key: "Volleyball", label: "search.vollyball", value: 19 },
];

// 厂商列表 -> Select options
export const makerList = (
  configStore.componentListMap.casino?.find(
    (item) => item.type === "maker_list",
  )?.makers || []
).map((item) => ({
  label: item.tag,
  value: item.tag,
  ...item,
}));

// subCategory - icon
export const subCategoryIconMap: Record<
  MainCategoryTypes,
  Record<string, svgPathTypes>
> = {
  Sports: {
    Live: "global-search/sport_live",
    Soccer: "global-search/soccer",
    Basketball: "global-search/basketball",
    Tennis: "global-search/tennis",
    Baseball: "global-search/baseball",
    Volleyball: "global-search/volleyball",
  },
  Casino: {
    "All Games": "global-search/all",
    Originals: "global-search/original",
    Slots: "global-search/slots",
    Live: "global-search/live",
    Show: "global-search/show",
    Special: "global-search/special",
    // Lottery: "global-search/lottery",
  },
};

export const SPORTS_ICON_MAP: Record<string, svgPathTypes> = {
  Soccer: "sports/betby/soccer",
  Basketball: "sports/betby/basketball",
  Tennis: "sports/betby/tennis",
  Baseball: "sports/betby/baseball",
  Volleyball: "sports/betby/volleyball",
  Football: "sports/betby/soccer",
};
